import innerEmitter from '../inner-emitter/inner-emitter';
import INNER_EVENT from '../inner-emitter/inner-event';
import { BaseRoom } from '../room-base';
import { ProcessHandler, createDecorator } from '../utils/decorators/middleware';
export const leaveInnerEvent = () => createDecorator((leave: ProcessHandler) => async function (this: BaseRoom, ...args: any[]) {
  innerEmitter.emit(INNER_EVENT.LEAVE_START, { room: this, roomId: this.roomId });
  await leave.call(this, ...args);
  innerEmitter.emit(INNER_EVENT.LEAVE_SUCCESS, { room: this, roomId: this.roomId });
});
